import styled from "styled-components";

export const Media = styled.section`
  position: relative;
  background: var(--secondary, #fff);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8rem 2.5rem 3rem 2.5rem;
  gap: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  h2 {
    font-family: "SourceSans3-Bold";
    color: var(--black2, #1d1d1d);
    font-size: 2rem;
    line-height: 2.2rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }
`;

export const MediaImg = styled.a`
  display: flex !important;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;
  height: 150px;

  img {
    width: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const MediaRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 59.25rem;
  gap: 2rem;
  z-index: 1;

  .Media {
    height: 0;
    width: 0;
  }
`;

export const CarouselWrapper = styled.div`
  width: 100%;

  .slick-slide {
    width: 200px;
  }

  .slick-prev::before,
  .slick-next::before {
    color: var(--primary, #000);
  }
`;